export default "__VITE_ASSET__CeJseAnG__"